import { message } from "antd";
export const useMessage = () => {
  message.config({
    top: 80,
    duration: 4,
  });

  function openMessage(type: string, msg = "") {
    switch (type) {
      case "success":
        message.success(msg);
        break;
      case "error":
        message.error(msg);
        break;
      default:
        break;
    }
  }

  return {
    openMessage,
  };
};
